import { createContext, useContext, useEffect, useState } from "react";
import { http } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading

  useEffect(() => {
    const t = localStorage.getItem("token");
    if (!t) { setUser(null); return; }
    http.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("token"); setUser(null); });
  }, []);

  async function login(username, password) {
    const { data } = await http.post("/auth/login", { username, password });
    localStorage.setItem("token", data.token);
    setUser(data.user);
    return data.user;
  }
  function logout() {
    localStorage.removeItem("token");
    setUser(null);
  }
  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
